export function getFormattedCount(number) {
  const parsedNumber = Number.parseInt(number, 10)

  if (!parsedNumber) {
    return '0'
  }

  let newNumber

  if (parsedNumber >= 1000000) {
    newNumber = (parsedNumber / 1000000)?.toFixed(1)
    if (newNumber - Math.floor(parsedNumber / 1000000) === 0) {
      newNumber = Math.floor(newNumber)
    }
    return `${newNumber}M`
  }

  if (parsedNumber >= 1000) {
    newNumber = (parsedNumber / 1000)?.toFixed(1)
    if (newNumber - Math.floor(parsedNumber / 1000) === 0) {
      newNumber = Math.floor(newNumber)
    }
    return `${newNumber}K`
  }

  return `${parsedNumber?.toFixed(0)}`
}
